import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperPagination from "../swiper/swiper-pagination";
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

// import required modules
import { FreeMode, Navigation, Thumbs, Pagination } from "swiper/modules";
import Image from "next/image";
import { MEDIA_BASE_URL } from "@/utils/api";

const Details_Slider = ({ productData, heading }) => {
  const mediaBaseUrl = MEDIA_BASE_URL;

  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  return (
    <div className="flex justify-between items-stretch">
      <div className="w-[18%] relative">
        <div className="absolute inset-0 h-[100%]">
          <Swiper
            onSwiper={setThumbsSwiper}
            spaceBetween={10}
            slidesPerView={4}
            freeMode={false}
            breakpoints={{
              0: {
                spaceBetween: 5,
              },
              768: {
                spaceBetween: 10,
              },
              1024: {
                spaceBetween: 10,
              },
            }}
            modules={[FreeMode, Navigation, Thumbs]}
            centeredSlides={false}
            centeredSlidesBounds={true}
            direction={"vertical"}
            className="mySwiper h-full verticleSwiper"
          >
            {productData &&
              productData?.map((item, i) => (
                <SwiperSlide
                  className="border-[1px] border-[#939498] lg:!h-[8vw]"
                  key={i}
                >
                  <div className="p-1 sm:p-2 h-full flex">
                    <Image
                      src={`${mediaBaseUrl}${item}`}
                      width={500}
                      height={500}
                      alt={heading}
                      className="m-auto !max-w-full max-h-[100%] w-auto h-auto"
                    />
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
        </div>
      </div>
      <div className="w-[79.5%] relative">
        <Swiper
          spaceBetween={10}
          navigation={false}
          pagination={{
            clickable: true,
            el: ".product-pagination",
          }}
          thumbs={{
            swiper:
              thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
          }}
          modules={[FreeMode, Navigation, Thumbs, Pagination]}
          className="mySwiper2 h-full"
        >
          {productData?.map((item, i) => (
            <SwiperSlide key={i} className="!flex h-auto lg:!h-[73vh]">
              <Image
                src={`${mediaBaseUrl}${item}`}
                width={500}
                height={500}
                alt="Products"
                className="m-auto block !max-w-[100%] max-h-[100%] w-auto h-auto"
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="absolute  w-full z-10 lg:bottom-[2vw] bottom-[20px]">
          <SwiperPagination
            customClass={"product-pagination relative w-full h-[auto] !mt-0"}
          />
        </div>
      </div>
    </div>
  );
};

export default Details_Slider;
